import { call, put, takeLatest } from "redux-saga/effects";

import {
    GET_TESTIMONIAL,
    getTestimonialFail,
    getTestimonialSuccess,
} from "../action/getTestimonialAction";

import getTestimonialApi from "../api/getTestimonialApi";

export function* getTestimonialSaga(action) {
    try {
        const response = yield call(() => getTestimonialApi(action.params))
        if (response.data.statusCode === 200) {
            yield put(getTestimonialSuccess(response, action))
        } else {
            yield put(getTestimonialFail(response, action))
        }
    } 
    catch (e) {
        yield put (getTestimonialFail(e.response, action))
    }
}

export default function* mySaga() {
    yield takeLatest(GET_TESTIMONIAL, getTestimonialSaga)
}